export default "__VITE_ASSET__CZfgi4YY__"